<template>
  <help-dialog title="Generate Example Data">
    <template #default>
      <h3 class="mb-1">Command</h3>
      <p class="text-grey-darken-3">
        You can let AI generate a <b>Command</b> with example data for each step in your workflow.
        The generated command are accessible for editing under the <b>Read Model & Command</b> tab.
        <br /><br />
      </p>
    </template>
  </help-dialog>
</template>

<script>
import HelpDialog from '@/components/HelpDialog.vue'

export default {
  components: {
    HelpDialog
  }
}
</script>
